export default __webpack_public_path__ + "static/media/team-view.a29e83c7.svg";